import script from "./ParkContactsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ParkContactsEditor.vue?vue&type=script&setup=true&lang=js"

import "./ParkContactsEditor.vue?vue&type=style&index=0&id=6499112a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6499112a"]])

export default __exports__